export default __webpack_public_path__ + "static/media/carpark.da607de5.png";